import "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";

document.addEventListener("DOMContentLoaded", () => {
	const cc = initCookieConsent();

	cc.run({
		current_lang: "sk",
		autoclear_cookies: true,
		page_scripts: true,
		remove_cookie_tables: true,
		revision: 0,
		languages: {
			"sk": {
				consent_modal: {
					title: "Na vašom súkromí nám záleží",
					description: "Vzhľadom k platnej legislatíve od vás ale potrebujeme súhlas s používaním súborov cookies.",
					primary_btn: {
						text: "Povoliť všetko",
						role: "accept_all"
					},
					secondary_btn: {
						text: "Nastavenia",
						role: "settings"
					}
				},
				settings_modal: {
					title: "Nastavenie cookies",
					save_settings_btn: "Uložiť nastavenia",
					accept_all_btn: "Povoliť všetko",
					reject_all_btn: "Zakázat všetko",
					close_btn_label: "Zavrít",
					blocks: [
						{
							title: "Co jsou cookies?",
							description: "Cookies sú malé textové súbory, ktoré môžu byť používané webovými stránkami, aby zefektívnili používateľský zážitok a zlepšili napríklad vašu orientáciu na webe.<br /><br />Zákon uvádza, že môžeme ukladať cookies na vašom zariadení, pokiaľ sú nevyhnutne nutné pre prevádzku tejto stránky. Pre všetky ostatné typy cookies potrebujeme vaše povolenie."
						}, {
							title: "Technické cookies (nezbytné)",
							toggle: {
								value: "necessary",
								enabled: true,
								readonly: true
							}
						}, {
							title: "Analytické cookies",
							toggle: {
								value: "analytics",
								enabled: false,
								readonly: false
							},
						}, {
							title: "Marketingové cookies",
							toggle: {
								value: "targeting",
								enabled: false,
								readonly: false
							}
						}, {
							title: "Kontakt",
							description: "Pre viac informácií nás kontaktujte na <a class=\"cc-link\" href=\"mailto:info@andys.sk\">info@andys.sk</a>.",
						}
					]
				}
			}
		}
	});
});
